import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=82c247c4&scoped=true"
import script from "./FormContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormContainer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormContainer.vue?vue&type=style&index=0&id=82c247c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c247c4",
  null
  
)

export default component.exports